import { debounce } from '@github/mini-throttle';
import { isMobile as isMobileForRoot, movePromoTiles, resetElementPositions, savePositions, DESKTOP_GRID_COLUMNS, MOBILE_GRID_COLUMNS, getRootFromAny, nextFrame } from './promo-tiles-utils';
import { ensureGlobalBindings, subscribe } from './promo-tiles-core';
// --- constants ---
const RESIZE_DEBOUNCE_TIME = 250;
const SLOT_SELECTOR = '.js-promo-tiles-slot';
const PRODUCTS_SELECTOR = '.js-product-grid > li:not(.js-promo-tiles-slot)';
// anchor present in your section: <ul id="product-grid" data-id="{{ section.id }}">
const PRODUCT_GRID_ANCHOR = '[data-id]';
// per-root lifecycle registry (for cleanup on section unload)
const registry = new Map();
const setupForContainer = async (root)=>{
    if (registry.has(root)) return;
    const applyLayout = async ()=>{
        // restore then re-place tiles based on current layout
        resetElementPositions(SLOT_SELECTOR, root);
        const cols = isMobileForRoot(root) ? MOBILE_GRID_COLUMNS : DESKTOP_GRID_COLUMNS;
        movePromoTiles(SLOT_SELECTOR, PRODUCTS_SELECTOR, cols, root);
    };
    savePositions('tile-slot', SLOT_SELECTOR, root);
    await nextFrame();
    await applyLayout();
    requestAnimationFrame(()=>{
        void applyLayout();
    });
    const onResize = debounce(()=>{
        void applyLayout();
    }, RESIZE_DEBOUNCE_TIME);
    window.addEventListener('resize', onResize);
    // Subscribe to the shared relayout scheduler (fires once per frame per root)
    const unsubscribe = subscribe(root, ()=>{
        void applyLayout();
    });
    registry.set(root, {
        cleanup: ()=>{
            window.removeEventListener('resize', onResize);
            unsubscribe();
        }
    });
};
const cleanupForContainer = (root)=>{
    const entry = registry.get(root);
    if (!entry) return;
    entry.cleanup();
    registry.delete(root);
};
export const init = async ()=>{
    // Bind shared listeners once (safe to call from multiple modules)
    ensureGlobalBindings({
        getRootFromAny
    });
    document.addEventListener('shopify:section:load', (e)=>{
        const el = e.target instanceof HTMLElement ? e.target : null;
        void setupForContainer(getRootFromAny(el));
    });
    document.addEventListener('shopify:section:unload', (e)=>{
        const el = e.target instanceof HTMLElement ? e.target : null;
        cleanupForContainer(getRootFromAny(el));
    });
    const boot = ()=>{
        document.querySelectorAll(PRODUCT_GRID_ANCHOR).forEach((anchor)=>{
            void setupForContainer(getRootFromAny(anchor));
        });
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, {
            once: true
        });
    } else {
        boot();
    }
    // optional global cleanup (if your infra calls it)
    return ()=>{
        document.querySelectorAll(PRODUCT_GRID_ANCHOR).forEach((anchor)=>{
            cleanupForContainer(getRootFromAny(anchor));
        });
    };
};
